import CarPoolsVehicleList from "./CarPoolsVehicleList";

/**
 * CarPoolsVehicleListOverview
 * Handles all JS stuff for vehicle list overview
 */
export default class CarPoolsVehicleListOverview {


    /**
     * constructor
     *
     * @param selector
     */
    constructor(selector) {
        let _this = this;
        this.$plugin = $(selector);
        let $plugin = this.$plugin;

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        _this.vehiclesNotByTuev();

        // advanced filter toggle
        $plugin.on('click', '[data-tncp-elementtoggler-trigger]', function () {
            let value = $(this).data('tncpElementtogglerTrigger');
            $plugin.find('[data-tncp-viewmode-value]').val(value);
        });
    }

    /**
     * vehiclesByTuev
     */
    vehiclesByTuev() {
        if (this.byTuevFilter instanceof CarPoolsVehicleList === false) {
            this.byTuevFilter = new CarPoolsVehicleList('[data-tncp-plugin="VehicleListByTuev"]');
        }
    }

    /**
     * vehiclesNotByTuev
     */
    vehiclesNotByTuev() {
        if (this.notByTuevFilter instanceof CarPoolsVehicleList === false) {
            this.notByTuevFilter = new CarPoolsVehicleList('[data-tncp-plugin="VehicleListNotByTuev"]');
        }
    }
}
